module.exports = ".mat-list-icon {\n    color: rgba(0, 0, 0, 0.54);\n  }\n  \n  mat-list-item{\n    background: #f6f6f6;\n    height: 50px!important;\n    margin-bottom:3px!important;\n  }\n  \n  .md-list-icon {\n    color: rgba(0, 0, 0, 0.54)!important;\n    cursor: pointer;\n  }\n  \n  .eliminar-carpeta {\n    color: rgba(0, 0, 0, 0.54)!important;\n    cursor: pointer;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/repositorio/repositorio.component.css
// module id = ./src/app/modulos/repositorio/repositorio.component.css
// module chunks = main